import { useEffect, useState } from "react";
import { Facebook, Instagram, Twitter, Youtube, Star } from "lucide-react";
import { apiClient } from "@/lib/api";

export const FALLBACK_SOCIALS = {
  facebook: "https://facebook.com/myhomeworkassist",
  instagram: "https://instagram.com/myhomeworkassist",
  x: "https://x.com/myhomeworkassist",
  youtube: "https://youtube.com/@myhomeworkassist",
  trustpilot: "https://trustpilot.com/review/myhomeworkassist.online",
};

const ICONS = {
  facebook: Facebook,
  instagram: Instagram,
  x: Twitter,
  youtube: Youtube,
  trustpilot: Star,
};

const LABELS = {
  facebook: "Facebook",
  instagram: "Instagram",
  x: "X (Twitter)",
  youtube: "YouTube",
  trustpilot: "Trustpilot",
};

export const useSiteSettings = () => {
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    apiClient.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
  }, []);
  return settings;
};

export const SocialLinks = ({ iconSize = 15, testidPrefix = "social", dark = false }) => {
  const settings = useSiteSettings();
  const socials = settings?.socials || FALLBACK_SOCIALS;

  return (
    <div className="flex items-center gap-1.5" data-testid={`${testidPrefix}-links`}>
      {Object.keys(ICONS).map((key) => {
        const Icon = ICONS[key];
        return (
          <a
            key={key}
            href={socials[key] || "#"}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={LABELS[key]}
            data-testid={`${testidPrefix}-${key}`}
            className={`flex h-8 w-8 items-center justify-center rounded-full border transition-colors duration-300 ${
              dark
                ? "border-[#12294D]/20 text-[#12294D] hover:border-[#A07E1F] hover:bg-[#D4AF37]/15 hover:text-[#A07E1F]"
                : "border-[#A07E1F]/25 text-[#A07E1F] hover:border-[#A07E1F] hover:bg-[#D4AF37]/15"
            }`}
          >
            <Icon size={iconSize} />
          </a>
        );
      })}
    </div>
  );
};
